/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Reload1Inputs */

const vi_sitesettings_reload1 = /** @type {(inputs: Sitesettings_Reload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải bản mới nhất`)
};

/**

* @param {Sitesettings_Reload1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_reload1 = /** @type {((inputs?: Sitesettings_Reload1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Reload1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_reload1(inputs)
});
export { sitesettings_reload1 as "siteSettings_reload" }